import * as React from 'react';
import styled from "styled-components";
import telegramIcon from '../../images/telegramIcon.svg';
import blueClose from '../../images/blueClose.svg'
import { useState } from "react";
import { Link } from "react-router-dom";

export const Container = styled.div<{ $color: string; }>`
    display: flex;
    padding-left: 6%;
    padding-right: 6%;
    padding-top: 16px;
    padding-bottom: 16px;
    background: ${({ $color }) => $color};
    align-items: center;
    gap: 8px;
    flex: 1 0 0;
`

type BlueAlertProps = {
    message: string,
    linkTelegram: string,
    open?: boolean,
    onClose?: () => void
}

export const BlueAlert: React.FC<BlueAlertProps> = ({ message, linkTelegram, open = true, onClose}) => {
    const [isOpen, setIsOpen] = useState(open);

    const closeHandler = () => {
        setIsOpen(false);
        if (onClose) {
            onClose();
        }
    }

    return (
        isOpen ? <Container $color={'#DDEFFD'}>
            <img src={telegramIcon} alt='' />
            <p><strong> Зарегистрируйтесь в чат-боте телеграмм! </strong>{message}<Link to={linkTelegram}> Зарегистрироваться </Link></p> 
            <img src={blueClose} style={{marginLeft:'auto', marginRight: '0px', cursor: 'pointer'}} onClick={closeHandler} alt=''/>
        </Container> : null
    )
}